import http from '../../utils/fetch';
export default {

    baseurl:'/api/select/shoudf',

    cesuan:'/api/select/cesuan/shoudf',

    selectUserAgentPage(q){
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: q
        });
    },
    selectUserAgentPageXm(q){
        return http({
            url: '/api/select/shoudfxm/selectPage',
            method: 'post',
            params: q
        });
    },
    getOneShoudf(usercode){
        return http({
            url: this.baseurl+'/getOneShoudf',
            method: 'post',
            params: {usercode}
        });
    },

    cesuanselectUserAgentPage(q){
        return http({
            url: this.cesuan+'/selectPage',
            method: 'post',
            params: q
        });
    },


    selectUserAgentList(q){
        return http({
            url: this.baseurl+'/selectList',
            method: 'post',
            params: q
        });
    },

    getQudaoXm(q){
        return http({
            url: '/api/select/shoudfxm/getQudaoXm?agentCode='+q,
            method: 'post',
           // params: q
        });
    },



}
